#
# The HTML preview loader – refreshes data from server until the
# fresh image is generated then injects it in-place
#
class @HtmlContentPreview

  @setup: ($section) ->

    # Initialization
    $value      = $section.find(".html-content-data")
    html        = $value.text()
    md5         = null # Assigned by the server when we request the render.
    pollTime    = 1.0
    maxTime     = 5000.0
    pollMult    = 2.0
    numTries    = 0
    maxTries    = 15
    ajaxTimeout = 30000
    giveUpAfter = 120000
    giveUpTimer = null
    finished    = false

    # Settle the preview. The loops below stop at their next callback, and
    # anything still in flight is ignored from here on.
    finish = ->
      finished = true
      window.clearTimeout(giveUpTimer)
      $(window).trigger("resize.stickem")

    # What we do when the render is done
    showImage = ->
      image = new Image()
      $(image).on "load", ->
        return if finished

        $image = $(image)
        $section
          .html(image)
          .css(height: "#{ $image.height() }px", width: "#{ $image.width() }px")
        finish()
      image.src = Routes.render_html_preview_tools_path(md5: md5)

    # What we do when the render never arrives. Say so, rather than leaving a
    # spinner turning indefinitely.
    showError = ->
      return if finished

      $section.empty().append($("<p/>").text(t("notices.preview_failed")))
      finish()

    # Polling alone cannot promise the spinner ever stops. Every retry below
    # hangs off an AJAX callback, and a request that never answers never fires
    # one — so there would be nobody left to notice we had run out of patience.
    # This timer is what actually makes the promise.
    giveUpTimer = window.setTimeout(showError, giveUpAfter)

    # Request that the html be rendered
    requestPreview = ->
      return if finished

      numTries = 0

      pollTime *= pollMult
      pollTime  = maxTime if pollTime > maxTime

      $.ajax
        type:    "POST"
        url:     Routes.render_html_preview_tools_path(md5: "")
        data:    { html: html }
        timeout: ajaxTimeout
        error:   -> delay pollTime, requestPreview
        success: (data) ->
          # The server tells us which md5 it filed the render under. Computing
          # it here instead risks disagreeing with Ruby's digest, which would
          # leave us polling for an image that is never going to show up.
          md5 = data.md5
          checkForPreview()

    # How we wait
    checkForPreview = ->
      return if finished

      pollTime *= pollMult
      pollTime  = maxTime if pollTime > maxTime

      if numTries < maxTries
        # Waiting for the render to finish. Request to see if it's done yet.
        numTries += 1

        $.ajax
          type:    "GET"
          url:     Routes.render_html_preview_tools_path(md5: md5)
          timeout: ajaxTimeout
          error:   -> delay pollTime, checkForPreview
          success: showImage
          accepts: { png: "image/png" }
      else
        # Send a new request. The first one probably timed-out.
        requestPreview()

    # Perform the preview
    requestPreview()
